import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// Vendored from shadcn — see ./index.ts for provenance and our divergences.
import * as React from "react";
import { MessageScroller as MessageScrollerPrimitive, useMessageScroller, useMessageScrollerScrollable, useMessageScrollerVisibility } from "@shadcn/react/message-scroller";
import { ArrowDownIcon } from "lucide-react";
import { cn } from "../../../utils";
import { Button } from "../../base/button/button";
function MessageScrollerProvider(props) {
    return /*#__PURE__*/ _jsx(MessageScrollerPrimitive.Provider, {
        ...props
    });
}
function MessageScroller({ className, ...props }) {
    return /*#__PURE__*/ _jsx(MessageScrollerPrimitive.Root, {
        "data-slot": "message-scroller",
        className: cn("group/message-scroller relative flex size-full min-h-0 flex-col overflow-hidden", className),
        ...props
    });
}
function MessageScrollerViewport({ className, ...props }) {
    return /*#__PURE__*/ _jsx(MessageScrollerPrimitive.Viewport, {
        "data-slot": "message-scroller-viewport",
        className: cn(// The bottom edge fade is gated on the primitive's own `data-scrollable`
        // state so the last message is not dimmed once the reader is at the end.
        "size-full min-h-0 min-w-0 scrollbar-thin scrollbar-gutter-stable overflow-y-auto overscroll-contain contain-content data-[scrollable~=end]:scroll-fade-b data-autoscrolling:scrollbar-thumb-transparent data-autoscrolling:scrollbar-track-transparent", className),
        ...props
    });
}
function MessageScrollerContent({ className, ...props }) {
    return /*#__PURE__*/ _jsx(MessageScrollerPrimitive.Content, {
        "data-slot": "message-scroller-content",
        className: cn("flex h-max min-h-full flex-col gap-8", className),
        ...props
    });
}
function MessageScrollerItem({ className, scrollAnchor = false, ...props }) {
    return /*#__PURE__*/ _jsx(MessageScrollerPrimitive.Item, {
        "data-slot": "message-scroller-item",
        scrollAnchor: scrollAnchor,
        className: cn("min-w-0 shrink-0 [contain-intrinsic-size:auto_10rem] [content-visibility:auto]", className),
        ...props
    });
}
function MessageScrollerButton({ direction = "end", className, children, render, label = direction === "start" ? "Scroll to oldest message" : "Scroll to newest message", ...props }) {
    return /*#__PURE__*/ _jsx(MessageScrollerPrimitive.Button, {
        "data-slot": "message-scroller-button",
        "data-direction": direction,
        direction: direction,
        className: cn("absolute inset-s-1/2 -translate-x-1/2 shadow-md transition-[translate,scale,opacity] duration-200 data-[active=false]:pointer-events-none data-[active=false]:scale-95 data-[active=false]:opacity-0 data-[active=false]:duration-400 data-[active=false]:ease-[cubic-bezier(0.7,0,0.84,0)] data-[active=true]:translate-y-0 data-[active=true]:scale-100 data-[active=true]:opacity-100 data-[active=true]:ease-[cubic-bezier(0.23,1,0.32,1)] data-[direction=end]:bottom-4 data-[direction=end]:data-[active=false]:translate-y-full data-[direction=start]:top-4 data-[direction=start]:data-[active=false]:-translate-y-full rtl:translate-x-1/2 data-[direction=start]:[&_svg]:rotate-180", className),
        render: render ?? /*#__PURE__*/ _jsx(Button, {
            variant: "outline",
            size: "icon-sm"
        }),
        ...props,
        children: children ?? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(ArrowDownIcon, {}),
                /*#__PURE__*/ _jsx("span", {
                    className: "sr-only",
                    children: label
                })
            ]
        })
    });
}
export { MessageScrollerProvider, MessageScroller, MessageScrollerViewport, MessageScrollerContent, MessageScrollerItem, MessageScrollerButton, useMessageScroller, useMessageScrollerScrollable, useMessageScrollerVisibility };

//# sourceMappingURL=message-scroller.js.map